{
  "id": "stable",
  "version": "1.0.0",
  "status": "stable",
  "owner": "granular",
  "createdAt": "2026-05-24T00:00:00.000Z",
  "changelog": "Baseline template wrapping the existing Granular agent harness prompt, continuation instruction, output contract, and generated-job review policy.",
  "promptBuilder": "buildGranularAgentSystemPrompt",
  "continuationBuilder": "buildContinuationInstruction",
  "modelOutputInstruction": "agent-evals:modelOutputInstruction",
  "codeReviewPolicy": "reviewGeneratedJobCode",
  "defaultModel": "gpt-5.6-luna",
  "modelMatrix": ["gpt-5.6-luna"],
  "temperature": 0,
  "compatibility": {
    "minSdkVersion": "0.4.40",
    "capabilities": [
      "executeCode",
      "readEntities",
      "workflowHelpers",
      "savedData",
      "showRecords"
    ]
  },
  "evalGates": {
    "requiredSuites": [
      "agent-harness-hardening",
      "agent-harness-runtime-e2e",
      "agent-production-readiness-e2e"
    ],
    "criticalBuckets": [
      "relationship-traversal",
      "cross-turn-reference",
      "ambiguous-target-choice",
      "confirmation-gated-mutation",
      "denied-action-refusal",
      "mutation-presentation"
    ],
    "maxRegressionPct": 0,
    "minPassK": {
      "critical-mutation": 0.9,
      "permission-boundary": 1
    }
  }
}
